(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    var container = document.querySelector('.pro-app-form');
    if (!container) return;

    var form = container.querySelector('.pro-app-form__form');
    var submitBtn = container.querySelector('.pro-app-form__submit');
    var submitText = container.querySelector('.pro-app-form__submit-text');
    var submitSpinner = container.querySelector('.pro-app-form__submit-spinner');
    var successDiv = container.querySelector('.pro-app-form__success');
    var errorDiv = container.querySelector('.pro-app-form__error');
    var errorText = container.querySelector('.pro-app-form__error-text');
    var proxyUrl = container.getAttribute('data-proxy-url');
    var storeKey = container.getAttribute('data-store-key') || 'leonlite_pro';

    if (!form || !submitBtn || !proxyUrl) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      // Clear previous errors
      clearErrors();

      // Validate
      var firstInput = form.querySelector('[name="first_name"]');
      var lastInput = form.querySelector('[name="last_name"]');
      var emailInput = form.querySelector('[name="email"]');
      var companyInput = form.querySelector('[name="company_name"]');
      var phoneInput = form.querySelector('[name="phone"]');
      var valid = true;

      if (!firstInput.value.trim()) {
        showFieldError(firstInput, 'First name is required');
        valid = false;
      }
      if (!lastInput.value.trim()) {
        showFieldError(lastInput, 'Last name is required');
        valid = false;
      }
      if (!emailInput.value.trim()) {
        showFieldError(emailInput, 'Email is required');
        valid = false;
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value.trim())) {
        showFieldError(emailInput, 'Please enter a valid email');
        valid = false;
      }
      if (!companyInput.value.trim()) {
        showFieldError(companyInput, 'Business name is required');
        valid = false;
      }
      if (!phoneInput.value.trim()) {
        showFieldError(phoneInput, 'Phone is required');
        valid = false;
      }

      if (!valid) return;

      // Disable submit
      submitBtn.disabled = true;
      submitText.hidden = true;
      submitSpinner.hidden = false;
      if (errorDiv) errorDiv.hidden = true;

      // Gather data — first + last merged into a single `name` for backend compatibility;
      // social_link retired from the form (sent as null).
      var firstName = form.querySelector('[name="first_name"]').value.trim();
      var lastName = form.querySelector('[name="last_name"]').value.trim();
      var data = {
        store_key: storeKey,
        name: (firstName + ' ' + lastName).trim(),
        email: form.querySelector('[name="email"]').value.trim(),
        phone: phoneInput.value.trim(),
        company_name: companyInput.value.trim(),
        social_link: null,
        honeypot_value: form.querySelector('[name="website_url_secondary"]').value || '',
      };

      // Submit
      fetch(proxyUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Submission failed (status ' + res.status + ')');
        return res.json();
      })
      .then(function() {
        // Success
        form.hidden = true;
        if (successDiv) successDiv.hidden = false;
      })
      .catch(function(err) {
        // Error
        if (errorDiv && errorText) {
          errorText.textContent = err.message || 'Something went wrong. Please try again.';
          errorDiv.hidden = false;
        }
        submitBtn.disabled = false;
        submitText.hidden = false;
        submitSpinner.hidden = true;
      });
    });

    function showFieldError(input, message) {
      input.classList.add('pro-app-form__input--error');
      var errorEl = document.createElement('span');
      errorEl.className = 'pro-app-form__field-error';
      errorEl.textContent = message;
      input.parentNode.appendChild(errorEl);
    }

    function clearErrors() {
      var errorEls = form.querySelectorAll('.pro-app-form__field-error');
      for (var i = 0; i < errorEls.length; i++) errorEls[i].remove();
      var errorInputs = form.querySelectorAll('.pro-app-form__input--error');
      for (var j = 0; j < errorInputs.length; j++) errorInputs[j].classList.remove('pro-app-form__input--error');
    }
  });
})();
